module.exports = __webpack_public_path__ + "static/img/pf-1.b250b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newYearActivity/pf-1.png
// module id = 90hs
// module chunks = 2